import type {DateValueEditorOptions, DateValueEditorValidations} from './types';
import type {Formatter, Parser} from '../../internal/forms/types';
import {DateTime, Info} from 'luxon';
import type {Validator} from 'svelte-forms';
import {isDefined} from 'shared/utils/custom-utils';
import {maxDateValidator, minDateValidator, requiredValidator} from '../../internal/validators';

export function validatorFactory(validations: DateValueEditorValidations): Validator[] {
    const validators: Validator[] = [];

    if (isDefined(validations.required) && validations.required) {
        validators.push(requiredValidator());
    }

    if (isDefined(validations.maxDate)) {
        validators.push(maxDateValidator(DateTime.fromISO(validations.maxDate).toISO()));
    }

    if (isDefined(validations.minDate)) {
        validators.push(minDateValidator(DateTime.fromISO(validations.minDate).toISO()));
    }

    return validators;
}


export function onlyDateParser(options: DateValueEditorOptions): Formatter {
    return (modelValue: string): string => {
        if (!options.onlyDate) {
            return modelValue;
        }
        return DateTime.fromISO(modelValue).toISODate();
    }
}

export function onlyDateFormatter(options: DateValueEditorOptions): Parser {
    return (viewValue: string): string => {
        if (!options.onlyDate) {
            return viewValue;
        }
        return DateTime.fromISO(viewValue).toISO();
    }
}

export function createLocalizationForLocale(locale: string) {
    const shiftArrayElements = (arr) => {
        arr.unshift(arr.pop());
        return arr;
    }

    return {
        days: shiftArrayElements(Info.weekdays('long', {locale})),
        daysShort: shiftArrayElements(Info.weekdays('short', {locale})),
        daysMin: shiftArrayElements(Info.weekdays('short', {locale})),
        months: Info.months('long', {locale}),
        monthsShort: Info.months('short', {locale}),
        meridiem: ['am', 'pm'],
        suffix: ['', '', '', ''],
    } as const;
}

export type DatePickerPhase = 'date' | 'hour' | 'minute';